// extracted by mini-css-extract-plugin
export default {"container":"TextBuildingBlockPicker_container__2U6mp","search":"TextBuildingBlockPicker_search__a7E1r","items":"TextBuildingBlockPicker_items__3qMI9"};